export default "__VITE_ASSET__j$psWiEn__"